<template>
  <v-snackbar v-model="snackbar" :color="snackbarData.color" bottom :timeout="8000">
    {{ snackbarData.text }}
    <v-btn class="mr-5 ml-0" text @click="hideSnackbar()">
      סגירה
    </v-btn>
  </v-snackbar>
</template>

<script>
export default {
  data: () => ({

  }),

  computed: {
    snackbar: {
      get()  {
        return this.$store.getters['snackbar'];
      },
      set(val) {
        return this.$store.commit('SET_SNACKBAR', val);
      }
    },
    snackbarData() {
      return this.$store.getters['snackbarData'];
    }
  },

  methods: {
    hideSnackbar() {
      this.$store.dispatch('HIDE_SNACKBAR');
    }
  }
};
</script>

<style scoped>
</style>
